import { render, staticRenderFns } from "./RELPassageirosLinhaDia.vue?vue&type=template&id=53587931&"
import script from "./RELPassageirosLinhaDia.vue?vue&type=script&lang=js&"
export * from "./RELPassageirosLinhaDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports